import BaseApi from 'app/services/common/base-api';

class UniversalLinkService extends BaseApi {
  constructor() {
    super(process.env.REACT_APP_ADMIN_API_URL, 'api/web/universal-link');
  }
}

export default new UniversalLinkService();
